import { Lock, Unlock, Wand2 } from "lucide-react";
import type { LockEvent } from "./blueprintTypes";

interface Props {
  events: LockEvent[];
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

function renderIcon(kind: LockEvent["kind"]) {
  if (kind === "locked") return <Lock size={14} className="mt-0.5 shrink-0 text-amber-500" />;
  if (kind === "generated") return <Wand2 size={14} className="mt-0.5 shrink-0 text-accent" />;
  return <Unlock size={14} className="mt-0.5 shrink-0 text-text-muted" />;
}

function verbFor(kind: LockEvent["kind"]): string {
  switch (kind) {
    case "locked":
      return "Locked";
    case "generated":
      return "Generated";
    default:
      return "Unlocked";
  }
}

export function BlueprintLockHistory({ events }: Props) {
  if (events.length === 0) return null;

  return (
    <div>
      <h4 className="mb-2 text-xs font-medium text-text-secondary">History</h4>
      <ul className="space-y-2">
        {events.map((e) => (
          <li key={e.id} className="flex items-start gap-2 text-xs">
            {renderIcon(e.kind)}
            <div className="flex-1">
              <span className="text-text-primary">
                {verbFor(e.kind)}
                {e.actor && <> by {e.actor.name}</>}
                {" on "}
                {formatDate(e.occurredAt)}
                {e.versionNumber != null && (
                  <span className="text-text-faint"> (v{e.versionNumber})</span>
                )}
              </span>
              {e.reason && <p className="mt-0.5 italic text-text-muted">"{e.reason}"</p>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
